import { accessTrackName } from "@/access/tracks";
import { useGetAccessEligibilityStatus } from "@/api/generated";
import {
  Button,
  Footer,
  Header,
  Heading,
  Paragraph,
  ScrollView,
} from "@/components";
import { useUserProgression } from "@/conversation/sidebar/UserProgression/UserProgressionContext";
import { accessIneligibleMessage } from "./accessEligibilityMessages";

/** Terminal step when CMS has not confirmed the user; acknowledging ends the enrollment. */
export const AccessIneligibleScreen = ({
  onAcknowledge,
}: {
  onAcknowledge: () => void;
}) => {
  const progression = useUserProgression()?.progression;
  const progressionId = progression?.id;
  const { data } = useGetAccessEligibilityStatus(
    { progression_id: progressionId ?? "" },
    {
      query: {
        enabled: Boolean(progressionId),
        meta: { suppressErrorToast: true },
      },
    },
  );
  const trackName = progression?.flow_name
    ? accessTrackName(progression.flow_name)
    : undefined;
  const programName = trackName ? `ACCESS ${trackName}` : "ACCESS";

  return (
    <>
      <ScrollView
        flex={1}
        contentContainerStyle={{
          flex: 1,
          paddingHorizontal: "$200",
          paddingBottom: "$400",
        }}
      >
        <Header gap="$100">
          <Heading size="$xl">We can't enroll you right now</Heading>
          <Paragraph>
            {accessIneligibleMessage(data?.result?.code, programName)}
          </Paragraph>
        </Header>
      </ScrollView>
      <Footer mode="dialog" padding="$200">
        <Button
          dataTrackingId="access-ineligible-acknowledge-button"
          mode="primary"
          constrained
          onPress={onAcknowledge}
        >
          Got it
        </Button>
      </Footer>
    </>
  );
};
